// States
import { UIState } from "#/store/states/UIState";
import { PageState } from "#/store/states/PageState";
import { ModelSelectionFilterState } from "#/store/states/ModelSelectionFilterState";
import { TypeSelectionFilterState } from "#/store/states/TypeSelectionFilterState";
import { WarenkorbState } from "./states/WarenkorbState";
import { ConverionWorldState } from "./states/ConversionWorldState";
import { ConverionWorldProductState } from "./states/ConversionWorldProductState";
import { ConversionWorldProductFilterState } from "./states/ConversionWorldProductFilterState";
import { ConversionWorldKonsiFilterState } from "./states/ConversionWorldKonsiFilterState";
import { ModulesState } from "./states/ModulesState";

export class Store {
  public static get instance() {
    if (!this.store) {
      this.store = new Store();
    }

    return this.store;
  }

  public static store: Store;

  public readonly ui: UIState;
  public readonly page: PageState;
  public readonly selectionFilter: ModelSelectionFilterState;
  public readonly typeSelectionFilter: TypeSelectionFilterState;
  public readonly warenkorb: WarenkorbState;
  public readonly conversionWorld: ConverionWorldState;
  public readonly conversionWorldProduct: ConverionWorldProductState;
  public readonly conversionWorldProductFilter: ConversionWorldProductFilterState;
  public readonly conversionWorldKonsiFilter: ConversionWorldKonsiFilterState;
  public readonly modules: ModulesState;

  private constructor() {
    this.ui = new UIState(this);
    this.page = new PageState(this);
    this.selectionFilter = new ModelSelectionFilterState(this);
    this.typeSelectionFilter = new TypeSelectionFilterState(this);
    this.warenkorb = new WarenkorbState(this);
    this.conversionWorld = new ConverionWorldState(this);
    this.conversionWorldProduct = new ConverionWorldProductState();
    this.conversionWorldProductFilter = new ConversionWorldProductFilterState();
    this.conversionWorldKonsiFilter = new ConversionWorldKonsiFilterState();
    this.modules = new ModulesState();
  }
}
